<template>
  <div class="modules">
    <div class="card-list">
      <card :card-title="$t('homepage.txt015')" title-image="chart" :show-gap="false" shadow="hover" style="height: 170px;" :count="count">
        <div class="tabs">
          <div class="tab-item" :class="{ 'disabled': !tabItem.count || tabItem.count == 0, 'no-permission': !tabItem.hasPermission }" v-for="(tabItem, tabIndex) in getTabs" :key="tabIndex" @click="toPage(tabItem)">
            <p class="count">{{ tabItem.count || 0 }}</p>
            <p class="tab-name">{{ $t(tabItem.statusText) }}</p>
          </div>
        </div>
      </card>
    </div>
    <card class="more" :body-style="bodyStyle" :show-gap="false" shadow="hover" @click="handleViewMore">
      <i class="icon el-icon-s-grid"></i>
      <span class="text">{{$t('homepage.txt014')}}</span>
    </card>

    <bsp-dialog :title="$t('homepage.txt012')" :dialog-visible.sync="visible" width="800px" class="dialog-card" @closeButton="handleClose">
      <template #body>
        <el-row class="dialog-card-list card-list" :gutter="15">
          <el-col :span="6" v-for="(tabItem, tabIndex) in tabs" :key="tabIndex">
            <card class="card-item">
              <div class="tabs">
                <div class="tab-item" :class="{ 'disabled': !tabItem.count || tabItem.count == 0, 'no-permission': !tabItem.hasPermission }" @click="toPage(tabItem)">
                  <p class="count">{{ tabItem.count || 0 }}</p>
                  <p class="tab-name">{{ $t(tabItem.statusText) }}</p>
                </div>
              </div>
            </card>
          </el-col>
        </el-row>
      </template>
      <template #footer>
        <el-button size="medium" @click="visible = false">{{$t('homepage.txt013')}}</el-button>
      </template>
    </bsp-dialog>
  </div>
</template>

<script>
  import Card from './Card'
  import BspDialog from "@/components/bsp/bsp-dialog/bsp-dialog";
  export default {
    name: "ApprovalModule",
    components: {
      Card,
      BspDialog
    },
    props: {
      tabs: {
        type: Array,
        default() {
          return []
        }
      },
      count: {
        type: [String, Number],
        default: 0
      }
    },
    data() {
      return {
        bodyStyle: {
          'display': 'flex',
          'flex-direction': 'column',
          'align-items': 'center',
          'justify-content': 'center'
        },
        visible: false
      }
    },
    methods: {
      handleViewMore() {
        this.visible = true
      },
      handleClose() {
        this.visible = false
      },
      toPage(val) {
        if(!val.hasPermission){
          return;
        }
        this.$emit('to',val)
      }
    },
    computed: {
      getTabs() {
        return this.tabs.slice(0, 4)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .modules {
    display: flex;
    justify-content: center;
    -webkit-box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    -moz-box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    -webkit-border-radius: 6px;
    -moz-border-radius: 6px;
    border-radius: 6px;
    overflow: hidden;
  }
  .card-list {
    flex: 1;
    .card-item:hover {
      color: #C73122;
      cursor: pointer;
    }
  }
  .dialog-card-list {
    padding: 0 8px;
    .card {
      margin-top: 8px;
      margin-bottom: 8px;
    };
  }
  .more {
    cursor: pointer;
    width: 70px;
    color: #C73122;
    .icon {
      font-size: 30px;
    }
    .text {
      font-size: 12px;
      line-height: 22px;
      height: 22px;
      margin-top: 5px;
    }
  }
  .tabs {
    display: flex;
    padding: 15px 0;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    .tab-item {
      line-height: 1;
      flex: 1;
      text-align: center;
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      box-sizing: border-box;
      cursor: pointer;
      &.disabled {
        color: #999;
      }
      &.no-permission {
        color: #999;
        cursor: no-drop;
      }
      &:not(.no-permission):hover {
        color: #C73122;
      }
      .count {
        font-size: 30px;
        margin-bottom: 12px;
      }
      .tab-name {}
    }
  }
</style>
